import React, {useEffect, useMemo, useState} from 'react';
import {Checkbox, Typography} from "@mui/material";
import {useLocation, useParams} from "react-router-dom";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import Box from "@mui/material/Box";
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from "material-react-table";
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import CustomerUserRolesServices from "../../../API/customer/CustomerUserRolesServices";
import {authorizedOrganization, constantsErrorMessages} from "../../../Constants";
import ModalAlert from "../../../components/UI/table/customer-detales/ModalAlert";
import {BreadcrumbsComponent} from "../../../components/UI/breadcrumb/BreadcrumbComponent";
import OrganizationUserRolesServices from "../../../API/organization/OrganizationUserRolesServices";

const UserRoles = () => {
        const pathname = useLocation().pathname
        const params = useParams();
        const {id} = params
        const profile = JSON.parse(localStorage.getItem("profile"))
        const isOrganization = profile?.userRoles.some(role => authorizedOrganization.includes(role.name))
        const [data, setData] = useState([])
        const [tableOptions, setTableOptions] = useState({
            pageIndex: 0,
            pageSize: 100,
            totalElements: 0,
            searchData: ""
        })
        const [alertData, setAlertData] = useState({});
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
        const api = isOrganization ? OrganizationUserRolesServices : CustomerUserRolesServices

        const handleChange = (row) => {
            api.edit(id, !row.enabled, row.id)
                .then(function (response) {
                    setData(prev => prev.map(el => el.id === row.id ? {
                        ...el,
                        enabled: !row.enabled,
                    } : el))
                }).catch(function (error) {
                handleModalAlert(error)
            })
        }

        const columns = useMemo(
            () => [
                {
                    id: 'name',
                    header: 'Наименование',
                    accessorKey: 'name',
                    size: 510,
                    grow: true,
                },
                {
                    id: 'description',
                    header: 'Описание',
                    accessorKey: 'description',
                    size: 510,
                    grow: true,
                },
                {
                    header: 'Активна',
                    accessorKey: 'enabled',
                    size: 8,
                    grow: false,
                    Cell: ({cell, row}) => <Checkbox
                        cell={cell}
                        checked={row.original.enabled}
                        onChange={() => handleChange(row.original)}
                        sx={{padding: "7px", '& .MuiSvgIcon-root': {fontSize: 22}}}
                    >
                    </Checkbox>,
                },
            ],
            [data, setData],
        );

        const tableOptionsHandle = (nextState) => {
            setTableOptions(nextState)
            if (nextState.pageSize !== tableOptions.pageSize) {
                EditLocalStoragePagesData(`${pathname}`, "pageSize", nextState.pageSize)
            }
        }

        const getStartPageSize = () => {
            const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
            const pageSize = pagesData[`${pathname}`]?.pageSize
            pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
        }

        useEffect(() => {
            getStartPageSize()
            api.getAll(id).then(function (response) {
                let data = response.data;
                setData(data);
                setTableOptions((prev) => ({...prev, totalElements: response?.data.length}))
                handleModalAlert("Данные изменены", 'success')
            })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        }, [])
        return (
            <Box sx={{width: '1800px', padding: "0 30px"}}>
                <BreadcrumbsComponent
                    page={"Роли пользователя"}
                    path={[{name: "Главная", href: "/"}, {name: "Настройки", href: "/settings"}]}/>
                <MaterialReactTable
                    renderTopToolbar={({table}) => {
                        return <Box sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "7px",
                            backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                        }}>
                            <MRT_ToolbarAlertBanner table={table}/>
                            <Box sx={{display: "flex"}}>
                                <MRT_ToggleFiltersButton table={table}/>
                                <MRT_GlobalFilterTextField table={table}/>
                            </Box>
                        </Box>
                    }}
                    muiTableContainerProps={{
                        sx: {
                            width: '1800px',
                        }
                    }}
                    muiTableBodyCellProps={{
                        sx: {
                            p: '0px 0px 0px 10px',
                            m: '0px 0px 0px 0px',
                            border: "none",
                            "&:after": {
                                display: "none",
                            },
                            "& td:after": {
                                "&:hover": {
                                    backgroundColor: "red"
                                }
                            },
                            "&:not(:last-of-type)": {
                                borderRight: '1px solid #EAEBEA',

                            },
                            "&:last-of-type": {
                                padding: 0,
                                width: 'calc(100% - 1px)',
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            },
                        },
                    }}
                    muiTableHeadCellProps={{
                        sx: {
                            border: '1px solid #EAEBEA',
                            backgroundColor: "#F5F6FA",
                            padding: "10px",
                            paddingBottom: " 0.2rem",
                            paddingTop: "0.2rem"
                        },
                    }}
                    muiTableBodyRowProps ={({row}) => {
                        return ({
                            sx: () => ({
                                height: '36px',
                                backgroundColor: "white",
                                "&:hover& td:after": {
                                    display: "none",
                                },
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light70,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                                "&:hover": {
                                    "& td:after": {
                                        display: "none",
                                    },
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                },
                                '&:nth-of-type(even)': {
                                    "&.MuiTableRow-root.Mui-selected": {
                                        backgroundColor: (theme) => theme.palette.primary.light,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.light50,
                                        },
                                    },
                                    backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.stroke,
                                    },
                                },
                            })
                        })
                    }}

                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            header: "",
                            size: 3,
                            minSize: 3,
                            grow: false,
                        },
                    }}
                    muiSearchTextFieldProps={{
                        placeholder: `Поиск`,
                        sx: {
                            paddingTop: "5px",
                            paddingBottom: "0px",
                            "& .MuiCollapse-root": {
                                borderRadius: '12px',
                                height: 40, width: 290,
                                "& .MuiSvgIcon-root": {
                                    color: "#737478"
                                },
                                '& .MuiOutlinedInput-input': {
                                    padding: 0
                                }
                            }
                        },
                        variant: 'outlined',
                    }}
                    state={{showGlobalFilter: true, pagination: tableOptions,}}
                    columns={columns}
                    data={data || []}

                    initialState={{
                        sorting: [{id: 'name', desc: false}],
                        columnVisibility: {
                            id: false,
                        },
                        isFullScreen: false,
                        density: "compact",
                        pagination: {pageIndex: 0, pageSize: 100},
                        columnPinning: {left: ['number']}
                    }}
                    onPaginationChange={(updater) => {
                        tableOptionsHandle(updater(tableOptions));
                    }}
                    rowCount={tableOptions.totalElements}
                    localization={MRT_Localization_RU}
                    enableToolbarInternalActions={false}
                    enableRowActions={false}
                    enableColumnActions={false}

                />
                <ModalAlert data={alertData} onClose={() => setAlertData((alert) => {
                    return {...alert, open: false}
                })}/>
            </Box>
        );
    }
;

export default UserRoles;